console.log('IMG1');

var multimap = new function(){

	var me = this;
	this.map;
	this.startZoom = 6,
	this.globalStateZoom = 7,
	this.globalTownZoom = 8,
	this.partnerZoom = 13,
	this.icon = '/images/marker.png',
	this.startLatLng;
	this.markers = [];
	this.fix = 10;

	this.initMap = function() {
		me.startLatLng = new google.maps.LatLng(51.9189046,19.1343786);
		me.map = new google.maps.Map(document.getElementById('distributors__map'), {
			zoom: me.startZoom,
			center:  me.startLatLng,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			icon: me.icon
		});
	};


	this.addMarkersToMapAll = function () {
		me.removeMarkers();
		var locations = new Array();
		$('.js-distributors__boxesItem').each(function(){
			latlng = $(this).attr("data-position").split(',');
			locations.push([latlng[0], latlng[1]]);
		});
		me.addMarkers(locations);
	};

	this.removeMarkers = function () {
		//remove all markers from map and memory
		for (var i = 0; i < me.markers.length; i++) {
			me.markers[i].setMap(null);
		}
		me.markers = [];
	};

	this.findInfoForMarker = function(marker) {
		var text = '',
		lat = marker.getPosition().lat().toFixed(me.fix),
		lng = marker.getPosition().lng().toFixed(me.fix);
		$('.distributors__boxesItem').each(function() {
			if(typeof $(this).attr('data-position') !== "undefined"){
				latlng = $(this).attr('data-position').split(',');
				if (lat == parseFloat(latlng[0]).toFixed(me.fix) && lng == parseFloat(latlng[1]).toFixed(me.fix)) {
					let img = $(this).attr('data-imageUrl') !== '' ? $(this).attr('data-imageUrl') : null;
					text = '<p class="name">' + $(this).find('.distributors__boxesItemName').html()+ '</p>';
          text = text + '<p>' + $(this).find('.distributors__boxesItemName--city').html() + '</p>';
					text = text + $(this).find('.distributors__boxesItemInfo--bottom').html();
          text = `<div class="infoBoxPop">` +
            (img !== null ? `<img class="infoBoxPop__img" src="${img}" alt="">` : '') +
            `<div>${text}</div></div>`;

					return false;
				}
				// text = $(this).find('.distributors__boxesInfo').html();
				// text = '<div class="infoBoxPop">'+ text +'</div>';
			}
		});
		return text;
	};

	this.findPositionForMarker = function(marker) {
		let lat = marker.getPosition().lat(),
			lng = marker.getPosition().lng();
		let pos = lat + ',' + lng;
		return pos;
	};

	this.addMarkersToMap = function () {
		me.removeMarkers();
		// set locations for markers
		var locations = new Array();
		var divs = $('.js-distributors__boxesItem:visible');
		$(divs).each(function() {
			latlng = $(this).data('position').split(',');
			locations.push([latlng[0], latlng[1]]);
		});
		me.addMarkers(locations);
	};

	this.addMarkers = function(locations) {
			// add markers to map
			for (i = 0; i < locations.length; i++) {
				var marker = new google.maps.Marker({
					position: new google.maps.LatLng(locations[i][0], locations[i][1]),
					map: me.map,
					icon: me.icon

				});
				me.markers.push(marker); // and remember them
				// if marker clicked => show info
				var infowindow = new google.maps.InfoWindow();
				google.maps.event.addListener(marker, 'click', (function(marker, i) {
					return function() {
						var text = me.findInfoForMarker(marker);
						var pos = me.findPositionForMarker(marker);
						infowindow.setContent(text);
						infowindow.open(me.map, marker);
						scrollToActiveItem(pos);
					}
				})(marker, i));
			}
	};

	me.addMarkersToMapAll();

	scrollToActiveItem = function(pos) {
		$(".js-distributors__boxesItem").removeClass('active');
		$(".js-distributors__boxesItem").each(function() {
			if ($(this).attr('data-position') === pos) {
				$(this).addClass('active');
				// $(this)[0].scrollIntoView();
				let scroll = $(this)[0].getBoundingClientRect().top + window.scrollY;
				// $(this).getBoundingClientRect().top + window.scrollY;
				$('.distributors__boxes')[0].scrollTo({top: scroll, behavior: 'smooth'});
			}
		});

	}

	this.findMarker = function (lat, lng) {
		var fix = 10;
		lat = parseFloat(lat).toFixed(fix);
		lng = parseFloat(lng).toFixed(fix);
		//console.log('finding latlng: '+lat+' '+lng);
		for (i = 0; i < me.markers.length; i++) {
			if (me.markers[i].getPosition().lat().toFixed(fix) == lat && me.markers[i].getPosition().lng().toFixed(me.fix) == lng) {
				//console.log('marker '+i+' latlng: '+markers[i].getPosition().lat()+" "+markers[i].getPosition().lng());
				return me.markers[i];
			}
		}
		return null;
	};

	this.changeSelect = function (value, element) {
		if ($('.distributors').length>0) { //
				var ll = element.data('value');
				if (typeof ll !== "undefined") {
					var latlng = ll.split(','),
					zoom = $(element).data('zoom');

					var ops = element.data('value');  //select latlng
					var opt_name = element.text();
					var opt_province = element.text();
					var selectClass = element[0].parentNode.parentElement.classList[1];

					if (selectClass == 'distributors__selectCountry') {
						$('.js-distributors__select select')[1].selectize.clear();
						$('.js-distributors__select select')[2].selectize.clear();
						$('#distributors__selectProvince').selectize()[0].selectize.enable();

						countryLatLng = (latlng.length == 2) ? new google.maps.LatLng(latlng['0'], latlng['1']) : startLatLng;
						countryZoom = (zoom) ? zoom : me.globalStateZoom;
						me.map.panTo(countryLatLng);
						me.map.setZoom(6);
					}else if (selectClass == 'distributors__selectProvince') {
						$('.js-distributors__select select')[2].selectize.clear();
						$('#distributors__selectCity').selectize()[0].selectize.enable();

						stateLatLng = (latlng.length == 2) ? new google.maps.LatLng(latlng['0'], latlng['1']) : startLatLng;
						stateZoom = (zoom) ? zoom : me.globalStateZoom;
						me.map.panTo(stateLatLng);
						me.map.setZoom(8);
					} else if (selectClass == 'distributors__selectCity') {
						townLatLng = (latlng.length == 2) ? new google.maps.LatLng(latlng['0'], latlng['1']) : startLatLng;
						townZoom = (zoom) ? zoom : me.globalStateZoom;
						me.map.panTo(townLatLng);
						me.map.setZoom(11);
					}


					$('.js-distributors__boxesItem').each(function(){
						$(this).removeClass('active').hide();
						if( $(this).data('country').toLowerCase()==opt_name.toLowerCase()) {
							$(this).show();
						} else if ($(this).data('province').toLowerCase()==opt_province.toLowerCase()) {
							$(this).show();
						} else if ($(this).data('city').toLowerCase()==opt_name.toLowerCase()) {
								$(this).show();
						}

						if($(this).data('position')==ll) {
							//$(this).addClass('active-member');
						}

					});

					// change map position and zoom
					me.addMarkersToMap();
					townLatLng = (latlng.length == 2)?new google.maps.LatLng(latlng['0'], latlng['1']):startLatLng;
					townZoom = (zoom)?zoom:me.globalStateZoom;
					me.map.panTo(townLatLng);
					//map.setZoom(11);

				}
			}
	};

	this.findByGelocation = function() {
		if(navigator.geolocation)
			navigator.geolocation.getCurrentPosition(this.showByGeolocation);
	}

	this.showByGeolocation = function(position){
		var points = $("[data-multimappoint-state]");
		var distance, coords;
		var minDistValue = 10000000000000;
		var minDistIndex = -1;
		for(var i=0;i<points.length;i++){
			coords = points.eq(i).attr('data-position').split(',');
			if(coords.length==2){
				distance = me.calcCrow(position.coords.latitude,position.coords.longitude,coords[0],coords[1]);
				if(distance<minDistValue){
					minDistValue = distance;
					minDistIndex = i;
				}
			}
		}
		if(minDistIndex!=-1){
			points.hide();
			points.eq(minDistIndex).show();
			me.addMarkersToMap();
		}
	}

	this.calcCrow = function(lat1, lon1, lat2, lon2){
		var R = 6371; // km
		var dLat = this.toRad(lat2-lat1);
		var dLon = this.toRad(lon2-lon1);
		var lat1 = this.toRad(lat1);
		var lat2 = this.toRad(lat2);

		var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
			Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
		var d = R * c;
		return d;
	}

	this.toRad = function(value){
			return value * Math.PI / 180;
	}

	me.bindEvents = function(){
		$(document).on('click', '.js-distributors__boxesItem .distributors__boxesItemHow', function(e) {
			e.preventDefault();
			var box = $(this).closest('.js-distributors__boxesItem');
			var latlng = box.attr('data-position').split(','),
				latLngObj = new google.maps.LatLng(latlng['0'], latlng['1']);
			// show info window
			google.maps.event.trigger(me.findMarker(latlng['0'], latlng['1']), 'click');
			// change map center position
			me.map.panTo(latLngObj);
			me.map.setZoom(15);
			$('html, body').animate({
					scrollTop: $('.distributors__map').offset().top - 150
			}, 600);

			box.addClass('active').siblings().removeClass('active');
		});

		if ($('.distributors').length) {
			$('.js-distributors__selectClear').on('click', function(){
				me.initMap();
				me.addMarkersToMapAll();
				$('.js-distributors__boxesItem').show();
			});
		}

		if($("[data-multimapfilter-submit]").length){
			$("[data-multimapfilter-submit]").bind('click',function(){
				$('[data-multimappoint-pointsale]').show();
				if($("[data-multimapfilter]:checked").length){
					for(let i=0; i<$('[data-multimappoint-pointsale]').length; i++){
						let hide = true;
            let includesChosenValues = {};
						['state','pointsale','salekind'].forEach(function(filter){
							let havingValues = $('[data-multimappoint-'+filter+']').eq(i).attr('data-multimappoint-'+filter).split(',');
							let choosenValues = $('[data-multimapfilter-'+filter+']:checked').map(function(key,el){ return ""+$(el).attr('data-multimapfilter-'+filter); });
							for(let j=0;j<choosenValues.length;j++) {
								if(havingValues.includes(choosenValues[j])) {
                  includesChosenValues[filter] = true;
                  break;
                }
                else {
                  includesChosenValues[filter] = false;
                }
              }
						});

            let allTrue = Object.values(includesChosenValues).every(value => value === true);
            hide = !allTrue;

						if(hide)
							$('.js-distributors__boxesItem').eq(i).hide();
					}
				}
				me.addMarkersToMap();
			});
		}
	};
};

$(document).ready(function(){
	if ($('.distributors').length>0) {
		multimap.initMap();
		multimap.addMarkersToMapAll();
		multimap.bindEvents();
		multimap.findByGelocation();
	}
});
